//export const CUSTOMER_SITE_PROXY_URL = 'http://192.168.1.137:8000';
//export const CUSTOMER_SITE_PROXY_URL = 'https://ecc-dev.towersystems.com.au';
//export const CUSTOMER_SITE_PROXY_URL = 'https://ecc-dev2.towersystems.com.au';
export const CUSTOMER_SITE_PROXY_URL = 'https://eccserver.towersystems.com.au';

export const OAUTH2_SERVER_URL = 'https://eccserver.towersystems.com.au';
//export const OAUTH2_SERVER_URL = 'https://ecc-dev2.towersystems.com.au';

export const CLIENT_URL = 'https://twc.towersystems.com.au';
//export const CLIENT_URL = 'https://ecc-client2.towersystems.com.au';